// import { Link as ScrollLink } from 'react-scroll';
import { Outlet } from 'react-router-dom';

// material
import { styled } from '@mui/material/styles';

// components
import NavRibbon, { NAV_RIBBON_HEIGHT } from '../../components/nav-ribbon';
import MainNavbar, { APP_BAR_DESKTOP, APP_BAR_MOBILE } from './nav';
import MainFooter from './footer';

import WhatsappFLoating from '../shared/WhatsappFLoating';
// ----------------------------------------------------------------------

const MainStyle = styled('main')(({ theme }) => ({
  flexGrow: 1,
  overflow: 'auto',
  minHeight: '100%',
  paddingTop: NAV_RIBBON_HEIGHT + APP_BAR_MOBILE + 24,
  paddingBottom: theme.spacing(15),
  [theme.breakpoints.up('lg')]: {
    paddingTop: NAV_RIBBON_HEIGHT + APP_BAR_DESKTOP + 24,

  },
}));

const SkipLink = styled('a')(({ theme }) => ({
  position: 'fixed',
  top: theme.spacing(1),
  left: theme.spacing(1),
  zIndex: theme.zIndex.tooltip + 1,
  padding: theme.spacing(1, 2),
  borderRadius: theme.shape.borderRadius,
  color: theme.palette.common.white,
  backgroundColor: theme.palette.grey[900],
  transform: 'translateY(-160%)',
  transition: theme.transitions.create('transform'),
  '&:focus': {
    transform: 'translateY(0)',
  },
}));
// ----------------------------------------------------------------------

export default function SimpleLayout() {
  // Was `{!isHome ? <MainFooter /> : <MainFooter />}`, so both branches were
  // identical and the `useLocation` read was dead. The footer is unconditional.
  return (
    <>
      <SkipLink href="#main-content">Skip to main content</SkipLink>
      <NavRibbon />
      <MainNavbar />
      <MainStyle id="main-content" tabIndex={-1}>
        <Outlet />
      </MainStyle>

      <MainFooter />
      <WhatsappFLoating />
    </>
  );
}
